<template>
  <el-form
    ref="loginFormRef"
    :model="LoginForm"
    class="login-form"
    :rules="rules"
  >
    <div class="login-title">
      <!--<h3 v-if="hrsaas">{{loginRole}}登录</h3>-->
      <!--<h3 v-else-if="isSaaS">{{loginRole}}系统登录</h3>-->
      <h3>用户登录</h3>
    </div>
    <el-form-item prop="loginName">
      <el-input
        ref="loginName"
        type="input"
        placeholder="请输入登录名或手机号"
        v-model="LoginForm.loginName"
        autocomplete="off"
        maxlength="20"
        v-on:keyup.enter.native="login"
        @change="loginNameChange"
      >
        <template slot="prepend">
          <i class="el-icon-user" />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item prop="password" style="margin-top: 22px">
      <el-input
        type="password"
        placeholder="请输入登录密码"
        v-model.trim="LoginForm.password"
        autocomplete="off"
        maxlength="20"
        v-on:keyup.enter.native="login"
        show-password
      >
        <template slot="prepend">
          <i class="el-icon-lock" />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item prop="captcha" style="margin-top: 22px">
      <el-input
        placeholder="请打开系统安全认证APP输入6位验证码"
        v-model.trim="LoginForm.captcha"
        maxlength="6"
        v-on:keyup.enter.native="login"
        @input="(res) => (LoginForm.captcha = validForbidOnlyNum_0(res))"
      >
        <template slot="prepend">
          <i class="el-icon-refresh-left" />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item v-if="adminDcVerify" prop="smsCode" style="margin-top: 22px">
      <el-row type="flex" align="middle">
        <el-col :span="10">
          <el-input
            type="input"
            placeholder="短信验证码"
            v-model.trim="LoginForm.smsCode"
            maxlength="6"
            autocomplete="off"
          ></el-input>
        </el-col>
        <el-col :span="14">
          <el-button
            type="primary"
            plain
            :disabled="this.getSmsCodeStatus"
            style="width: 100%; height: 47px"
            @click="getSmsCode('loginFormRef')"
            >{{ this.getSmsCodeName }}
          </el-button>
        </el-col>
      </el-row>
    </el-form-item>
    <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '400px', height: '200px' }"
      @success="indexLogin"
    />
    <!-- <el-form-item v-if="showVerify" prop="verify" style="margin-top: 22px">
      <el-row>
        <el-col :span="16">
          <el-input
            type="input"
            placeholder="图片验证码（区分大小写）"
            v-model="LoginForm.verify"
            autocomplete="off"
          ></el-input>
        </el-col>
        <el-col :span="8" style="height: 47px">

          <el-image
            @click="changeImgCode"
            fit="fill"
            :src="verifyUrl"
            style="width: 100%; height: 47px; cursor: pointer; float: right"
          />

        </el-col>
      </el-row>
    </el-form-item> -->
    <el-button
      type="text"
      style="margin: 0; margin-bottom: 12px; float: right"
      @click="forgotPass"
      >忘记密码？</el-button
    >
    <br />
    <el-button
      type="primary"
      style="width: 100%; margin-bottom: 10px"
      @click="indexLogin"
      v-loading.fullscreen.lock="fullscreenLoading"
      >登 录
    </el-button>
    <el-divider class="login-divider"></el-divider>
    <!--<el-button type="text" @click="registBtn">立即注册{{loginRoleName}}</el-button>-->
    <el-button type="text" v-if="!isZbrl" @click="registBtn"
      >立即注册</el-button
    >
  </el-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ls from '@/utils/ls'
import userAPI from '@/api/userAPI.js'
import aEntityAPI from '@/api/sysAPI.js'
import aes from './aes.js'
import Verify from '@/components/verifition/Verify'
export default {
  components: {
    Verify
  },
  props: ['mobile', 'saas', 'fromUrl'],
  data() {
    const validatePass = (rule, value, callback) => {
      if (value == '') {
        callback()
      } else {
        callback('双因子认证验证码错误')
      }
    }
    return {
      isZbrl: false,
      fullscreenLoading: false,
      hrsaas: false,
      adminDcVerify: false, //等保针对管理员，double check sms verify
      getSmsCodeName: '获取短信验证码',
      getSmsCodeStatus: false,

      LoginForm: {
        loginName: '',
        password: '',
        smsCode: '',
        verify: '',
        captcha: ''
      },
      showVerify: false,
      verifyUrl:
        window.location.protocol +
        '//' +
        window.location.host +
        process.env.VUE_APP_BACKEND_URL_PROXY +
        '/verify?randid=' +
        Math.abs(Math.sin(new Date().getTime())),
      rules: {
        loginName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'change'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'change'
          }
        ],
        smsCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'change'
          }
        ],
        verify: [
          {
            required: true,
            message: '请输入图片验证码',
            trigger: 'change'
          }
        ],
        captcha: [{ required: true, trigger: 'blur', validator: validatePass }]
      },
      loginRole: '',
      loginRoleName: '',
      isSaaS: false
    }
  },
  computed: {
    ...mapGetters({
      userinfo: 'user/userinfo',
      sysConfig: 'config/sysConfig',
      shipper: 'user/shipper',
      __menu: 'user/menu'
    })
  },

  created() {
    if (ls.get('LoginError') != null && ls.get('LoginError') == 1) {
      this.showVerify = true
    }
  },

  methods: {
    ...mapActions(['user/login', 'user/logout', 'user/checkLogin']),
    validForbidOnlyNum_0(value) {
      return value.replace(/[^\d]/g, '')
    },
    loginNameChange(v) {
      /*检查是否需要图片验证码*/
      userAPI.needVerify(v).then((response) => {
        //双要素验证
        if (response.status != null && response.status == 200) {
          if (response.data.needVerify) {
            this.showVerify = true
          }
        }
      })

      //需要双要速验证
      if (this.sysConfig.adminSmsVerifyLogin) {
        userAPI.checkAdmin(v).then((response) => {
          //双要素验证
          if (response.status != null && response.status == 200) {
            if (response.data.admin) {
              this.$message({
                message: '已启用超管的密码 + 短信验证码双要素登录策略',
                type: 'info'
              })
              this.adminDcVerify = true
              return
            }
          }

          this.adminDcVerify = false
        })
      }
    },

    //获取短信验证码
    getSmsCode(ref) {
      let valid = true
      this.$refs[ref].clearValidate()
      // this.$refs[ref].validateField(["registName", "registImgCode"], err => {
      //   if (err != "") {
      //     valid = false;
      //   }
      // });

      if (valid) {
        let params = {
          mobile: this.LoginForm.loginName
        }

        userAPI.getSmsCode(params).then((response) => {
          if (response.status != null && response.status == 200) {
            this.waitCodeTime()
          } else {
            let message =
              response.data.message == null
                ? '获取验证码失败'
                : response.data.message
            this.$message({
              message: message,
              type: 'error'
            })
          }
        })
      }
    },

    //短信验证码倒计时
    waitCodeTime() {
      let waitSeconds = 60
      this.getSmsCodeStatus = true
      var interval = setInterval(() => {
        waitSeconds--
        this.getSmsCodeName = '校验码已发送，请等待' + waitSeconds + '秒重试'
        this.getSmsCodeStatus = true
        if (waitSeconds < 1) {
          this.getSmsCodeName = '没收到验证码？重新获取'
          this.getSmsCodeStatus = false
          clearInterval(interval)
        }
      }, 1000)
    },

    indexLogin() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          var param = { ...this.LoginForm }
          if (this.adminDcVerify == true) {
            // param.smsVerify = this.LoginForm.smsCode; //短信验证码设置为双要素的短信校验码
            param.smsCode = '' //避免与短信验证码登录冲突
          }
          //加密密码防止泄露
          param.passwordE = aes.encrypt(param.password)
          param.password = null
          console.log(param)
          if (this.hrsaas) {
            param.platform = 7
          }
          if (this.isSaaS) {
            param.platform = 2
          }
          console.log(param)
          if (localStorage.getItem('errorTimes') >= 3) {
            this.$refs.verify.show()
          } else {
            this.fullscreenLoading = true
            this['user/login'](param).then((data) => {
              this.fullscreenLoading = false
              if (data.success) {
                console.log(data)
                var tenantInfo = data.tenantInfo
                if (
                  tenantInfo != null &&
                  tenantInfo.status != null &&
                  ((typeof tenantInfo.status == 'object' &&
                    [-7, -5].indexOf(tenantInfo.status.value) > -1) ||
                    (typeof tenantInfo.status == 'string' &&
                      ['已提交帐号', '已提交授权'].indexOf(tenantInfo.status) >
                        -1)) &&
                  (this.isSaaS || this.hrsaas)
                ) {
                  //saas注册用户的tenantInfo的状态还在待审核阶段，需转到到saas注册页面
                  // window.location.href = "login.html#/regSaas"
                  this.$router.push({
                    name: 'regSaas'
                  })
                  return
                }
                if (sessionStorage.getItem('beforeLoginUrl') == null) {
                  if (data.user.firstLogin) {
                    //首次登录
                    this.$router.push({ name: 'resetPass' })
                  } else {
                    if (this.fromUrl != null && this.fromUrl) {
                      window.location.href = decodeURIComponent(this.fromUrl)
                    } else {
                      //判断默认进入的系统
                      if (this.__menu.length == 1) {
                        //一个系统菜单，只进这个系统
                        const url = this.__menu[0].url
                        window.location.href = url
                      } else if (this.__menu.length > 1) {
                        //多个系统菜单
                        let manageFlag = false
                        for (var i = 0; i < this.__menu.length; i++) {
                          if (this.__menu[i].mxtype == 'manage') {
                            manageFlag = true
                          }
                        }

                        if (manageFlag) {
                          window.location.href = 'manage.html#/home'
                        } else {
                          const url = this.__menu[0].url
                          window.location.href = url
                        }
                      } else {
                        //无菜单
                        this.$alert('无系统权限，将返回登录', '登录失败', {
                          confirmButtonText: '确定',
                          callback: (action) => {
                            this['user/logout']().then(() => {
                              window.location.reload()
                            })
                          }
                        })
                      }
                    }
                  }
                } else {
                  var beforeLoginUrl = sessionStorage.getItem('beforeLoginUrl')
                  sessionStorage.removeItem('beforeLoginUrl')
                  window.location.href = beforeLoginUrl
                }
              } else {
                let message = data.msg == null ? '' : data.msg
                if (message == '该号码未注册') {
                  // this.registBtn();
                  this.$message({
                    message: '该手机号未注册，请您先注册！',
                    type: 'error'
                  })
                } else {
                  if (data.errorCode == 407) {
                    this.$message({
                      message: '已启用超管的密码 + 短信验证码双要素登录策略',
                      type: 'info'
                    })
                    this.adminDcVerify = true
                    return
                  }
                  if (data.errorTimes >= 3 || message == '图片验证码不正确') {
                    localStorage.setItem('errorTimes', data.errorTimes)
                    // this.showVerify = true;
                    this.$refs.verify.show()

                    ls.set('LoginError', 1)
                  }

                  this.$message({
                    message: message,
                    type: 'error'
                  })
                  if (this.showVerify) {
                    //刷新验证码
                    // this.changeImgCode();
                  }
                }
              }
            })
          }
        }
      })
    },
    registBtn() {
      this.$router.push({ name: 'reg' })
    },
    forgotPass() {
      this.$router.push({ name: 'forgotPass' })
    },
    changeImgCode() {
      this.LoginForm.verify = '' //清空验证码

      this.verifyUrl =
        window.location.protocol +
        '//' +
        window.location.host +
        process.env.VUE_APP_BACKEND_URL_PROXY +
        '/verify?randid=' +
        Math.abs(Math.sin(new Date().getTime()))
    }
  },

  mounted() {
    var href = window.location.href
    if (this.mobile) {
      this.LoginForm.loginName = this.mobile
    }

    if (href.indexOf('hrsaas') > -1 || href.indexOf('saas.gz-vip.com') > -1) {
      this.hrsaas = true
      this.loginRole = '工众人力平台'
      this.loginRoleName = '工众人力平台用户'
    } else if (window.location.host.indexOf('saas.') > -1) {
      this.saas = true
    }
    if (this.saas != null) {
      this.loginRole = 'SaaS'
      this.isSaaS = true
      this.loginRoleName = 'SaaS用户'
    }

    if (
      href.indexOf('zbrl.gsh56.com') > -1 ||
      href.indexOf('testzbrl.gsh56test.com') > -1
    ) {
      this.isZbrl = true
    }
    console.log(this.loginRole)

    var that = this
    setTimeout(function () {
      that.$refs['loginName'].focus()
    }, 250)
  }
}
</script>
<style>
.login-divider.el-divider--horizontal {
  margin: 12px 0;
}
</style>
